// extracted by mini-css-extract-plugin
module.exports = {"TableRow":"TableRow_TableRow__PcjY1"};